import React from "react";
import { useConfig, useTicket } from "../../store/Store";
import TicketHeader from "./TicketHeader";
import DebugInfo from "../general/DebugInfo";
import AdjustmentsList from "../adjustments/AdjustmentsList";
import { GiftCardInput, PromoCodeInput } from "../adjustments/Discounts";
import { formatDate } from "../general/AppHelpers";

const Ticket = () => {
  const { data: ticketData } = useTicket();
  const config = useConfig();

  if (!ticketData) {
    return null;
  }

  return (
    <div className="w-full basis-3/5 p-8 rounded-lg border-gray-200">
      {/* Ticket Header */}
      <div className="pb-6 border-b">
        <TicketHeader />
      </div>

      <div className="space-y-6">
        {config.debug && (
          <div className="bg-white p-4 rounded-lg">
            <DebugInfo
              ticketData={ticketData}
              formatDate={formatDate}
              textColor={config.textColor}
            />
          </div>
        )}

        <div>
          <div className="bg-white p-2 rounded-lg">
            <AdjustmentsList />
          </div>
          <div className="pt-5 border-t border-gray-200">
            <div className="bg-white rounded-lg">
              <GiftCardInput />
            </div>
            <div className="bg-white rounded-lg">
              <PromoCodeInput />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ticket;
